<div class="main-container" *ngIf="!isLoading" data-cy="note-boilerplates-main-container">
  <div *ngIf="showContext" data-cy="note-boilerplates-context-wrapper">
    <app-note-boilerplates-context
      [positionX]="contextPositionX"
      [positionY]="contextPositionY"
      [actionsDisabled]="disableContextActions"
      [clickedEmptySpace]="clickedEmptySpace"
      (edit)="handleEditEvent()"
      (delete)="handleDeleteEvent()"
      (addNew)="handleAddNewEvent()">
    </app-note-boilerplates-context>
  </div>

  <div class="left-side-container" (click)="hideContextMenu()" oncontextmenu="return false;" data-cy="note-boilerplates-list-container">
    <div cdkDropList
         [cdkDropListData]="dataNoteSet.dataPredefinedNotes"
         [cdkDropListConnectedTo]="[]"
         (cdkDropListDropped)="drop($event)"
         #dropList="cdkDropList"
         data-cy="note-boilerplates-drag-list">
      <div class="note-description"
           [class.active]="activePredefinedNote === predefinedNote"
           *ngFor="let predefinedNote of dataNoteSet.dataPredefinedNotes"
           (contextmenu)="onRightClickEvent($event, predefinedNote, false)"
           (click)="selectPredefinedNote(predefinedNote)"
           cdkDrag
           data-cy="note-boilerplates-item">
        {{ predefinedNote.NoteDescription }}
      </div>
    </div>
    <div class="under-div" (contextmenu)="onRightClickEvent($event, getLastNote(), true)" data-cy="note-boilerplates-empty-area">
    </div>
  </div>

  <div class="right-side-container" (click)="hideContextMenu()" data-cy="note-boilerplates-preview-container">

    <mat-form-field class="note-input" data-cy="note-boilerplates-preview-field">
      <textarea matInput class="" placeholder="Note preview" [(ngModel)]="notePreview" [rows]="25" (keyup)="setNote($event)" data-cy="note-boilerplates-preview-input"></textarea>
    </mat-form-field>

  </div>

  <div class="action-container" data-cy="note-boilerplates-action-container">

    <div class="save-all-spinner" *ngIf="isSaving" matTooltip="Saving changes" data-cy="note-boilerplates-saving-spinner">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>

    <button mat-button class="action-button" color="warn" (click)="cancel()" data-cy="note-boilerplates-cancel-button">Cancel</button>
    <button mat-raised-button class="action-button" color="primary" (click)="save()" data-cy="note-boilerplates-save-button">Ok</button>
  </div>

</div>

<div *ngIf="isLoading" data-cy="note-boilerplates-loading-container">
  <div class="spinner-div" data-cy="note-boilerplates-spinner-div">
    <div class="spinner-holder" data-cy="note-boilerplates-spinner-holder">
      <mat-spinner data-cy="note-boilerplates-spinner"></mat-spinner>
    </div>
  </div>
</div>
